import React, { FC } from 'react';

import { IAdminClub } from '../../../../../store/admin/clubs/store';

import notificationIcon from '../../../../../assets/images/menu_icons/announcement.png';
import Tooltip from '../../../../../components/Tooltip';
import { useBoolean } from '../../../../../scenes/common/Hooks/useBoolean.hook';
import SendNotificationForm from '../../../../SendNotificationForm/SendNotificationForm';
import { SendNotificationModalStyled } from './SendNotificationModal.styles';

interface IProps {
  club: IAdminClub;
}

const SendNotification: FC<IProps> = props => {
  const { club } = props;

  const [showModal, setShowModal, toggleShowModal] = useBoolean(false);

  return (
    <>
      <div className="sidemenu-nav-item withBottomBorder">
        <img src={notificationIcon} className="icon" alt="Send Notification Icon" />

        <div className="link" onClick={toggleShowModal}>
          SEND A CLUB NOTIFICATION
        </div>
      </div>

      <SendNotificationModalStyled
        onClose={toggleShowModal}
        className="staff-scope send-notification-dialog"
        open={showModal}
        title="SEND A NOTIFICATION"
        tooltip={<Tooltip sectionKey="NOTIFICATION.SEND" />}
      >
        <SendNotificationForm
          submitCallback={() => {
            setShowModal(false);
          }}
          club={club}
        />
      </SendNotificationModalStyled>
    </>
  );
};

export default SendNotification;
